module.exports = __webpack_public_path__ + "media/images/recruit/entry/icon-order-entry-c61b50bbd65224a1117b04c76ec6b6d6.svg";